
import Autocomplete from '@/ui-kit/components/autocomplete';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';

export default {
  name: 'SearchAutocomplete',
  components: {
    Autocomplete,
  },
  props: {
    value: {
      default: '',
      type: String,
    },
    options: {
      default: () => [],
      type: Array,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    isLoading: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      StyleColorSchemeType,
    };
  },
  methods: {
    handleAutocompleteChange(value) {
      this.$emit('change', value);
    },
    handleAutocompleteSelect(value) {
      this.$emit('select', value);
    },
  },
};
